import React from "react";
import Grid from "../Grid/Grid";
import GridItem from "../GridItem/GridItem";
import EditorialCard from "../EditorialCard/EditorialCard";
import featuredPostImage from "../../utils/featuredPostImage";
import formatUrl from "../../utils/formatUrl";

import "./relatedContent.css";

export const RelatedContent = ({ relatedContent, category }) => {
  const squircleHexValue = "#046062";
  return (
    <>
      <section className="coop-l-section coop-l-section--bottom-squircle-category coop-c-related-content coop-u-margin-resp-t-64-48">
        <div className="coop-l-section__inner coop-l-container coop-u-padding-resp-t-64-48 coop-u-padding-b-64">
          <h2 className="coop-c-related-content__title">More in {category}</h2>
          <Grid className="coop-u-flex coop-c-category-list">
            {relatedContent.nodes.map((content, index) => (
              <GridItem
                className="coop-u-flex"
                sm={12}
                md={4}
                lg={4}
                key={content.id}
              >
                <EditorialCard
                  key={index}
                  title={content.title}
                  titleClass="coop-u-title-26"
                  link={formatUrl(content.slug)}
                  subtitle={category}
                  content={content.excerpt}
                  imageData={featuredPostImage(content.featuredImage)}
                />
              </GridItem>
            ))}
          </Grid>
        </div>
        <div className="coop-l-section__squircle">
          <div className="coop-l-section__squircle__inner">
            <svg
              className="coop-l-section__squircle__svg"
              viewBox="0 0 1440 600"
              fill={squircleHexValue}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1709.31 300.715C1637.12 187.758 1456.9 98.8323 1215.71 56.8073C745.108 -19.0001 228.429 -19.0001 -247.002 57.1943C-485.903 98.8323 -665.305 187.758 -739.046 301.063C-795.437 391.885 -824 486.073 -824 581.384C-824 676.695 -795.437 770.883 -739.046 862.053C-665.223 975.01 -485.903 1063.94 -245.447 1105.96C-9.73651 1143.84 236.286 1163 485.5 1163C735.533 1163 981.555 1143.84 1218 1105.57C1457.72 1063.55 1637.04 974.971 1709.23 861.666C1766.44 770.148 1795 675.959 1795 581.384C1795 486.808 1766.44 392.272 1709.31 300.715Z"
                fill={squircleHexValue}
              />
            </svg>
          </div>
        </div>
      </section>
    </>
  );
};
